//assets
import Pic1 from "../../../assets/images/about1sec.png";
import { Title } from "../../global/title/title";
export const Sec1 = () => {
  return (
    <div className="about-sec section">
      <div className="about-sec__box">
        <img src={Pic1} alt="img1" className="about-sec__img" />
      </div>
      <div className="about-sec__box  about-sec__box--text about-sec__box--text-right ">
        <Title black="About" blue=" Dr.Derm" />
        <p className="paragraph text--gray ">
          Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
          sint. Velit officia consequat duis enim velit mollit. Exercitation
          veniam consequat sunt nostrud amet.
        </p>
        <p className="paragraph text--gray">
          Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
          sint. Velit officia consequat duis enim velit mollit. Exercitation
          veniam consequat sunt nostrud amet.
        </p>
      </div>
      <div className="about-sec__elapses">
        <Elapses />
      </div>
    </div>
  );
};

const Elapses = () => {
  return (
    <svg
      width="271"
      height="427"
      viewBox="0 0 271 427"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M213.356 426.407C95.7925 426.407 0.152344 330.767 0.152344 213.203C0.152344 95.6402 95.7925 0 213.356 0C330.919 0 426.559 95.6402 426.559 213.203C426.533 330.767 330.892 426.407 213.356 426.407ZM213.356 2.69374C97.2594 2.69374 2.81939 97.1338 2.81939 213.23C2.81939 329.327 97.2594 423.767 213.356 423.767C329.452 423.767 423.892 329.327 423.892 213.23C423.892 97.1338 329.426 2.69374 213.356 2.69374Z"
        fill="#3376FE"
        fill-opacity="0.2"
      />
      <path
        d="M213.358 405.817C107.156 405.817 20.7437 319.404 20.7437 213.203C20.7437 107.001 107.156 20.5889 213.358 20.5889C319.559 20.5889 405.971 107.001 405.971 213.203C405.971 319.431 319.559 405.817 213.358 405.817ZM213.358 25.9497C110.09 25.9497 26.0777 109.962 26.0777 213.229C26.0777 316.497 110.09 400.509 213.358 400.509C316.626 400.509 400.637 316.497 400.637 213.229C400.637 109.962 316.626 25.9497 213.358 25.9497Z"
        fill="#3376FE"
        fill-opacity="0.2"
      />
      <path
        d="M213.353 352.343C136.649 352.343 74.2397 289.934 74.2397 213.23C74.2397 136.526 136.649 74.1173 213.353 74.1173C290.057 74.1173 352.466 136.526 352.466 213.23C352.466 289.934 290.057 352.343 213.353 352.343ZM213.353 79.4247C139.582 79.4247 79.5738 139.433 79.5738 213.204C79.5738 286.974 139.582 346.983 213.353 346.983C287.123 346.983 347.132 286.974 347.132 213.204C347.132 139.46 287.123 79.4247 213.353 79.4247Z"
        fill="#3376FE"
        fill-opacity="0.2"
      />
      <path
        d="M213.356 328.42C149.827 328.42 98.1396 276.733 98.1396 213.204C98.1396 149.675 149.827 97.9873 213.356 97.9873C276.885 97.9873 328.572 149.675 328.572 213.204C328.572 276.759 276.885 328.42 213.356 328.42ZM213.356 100.654C151.294 100.654 100.807 151.141 100.807 213.204C100.807 275.266 151.294 325.753 213.356 325.753C275.418 325.753 325.905 275.266 325.905 213.204C325.905 151.168 275.418 100.654 213.356 100.654Z"
        fill="#3376FE"
        fill-opacity="0.2"
      />
      <path
        d="M213.356 284.894C173.831 284.894 141.693 252.756 141.693 213.231C141.693 173.705 173.831 141.567 213.356 141.567C252.882 141.567 285.02 173.705 285.02 213.231C285.02 252.73 252.855 284.894 213.356 284.894ZM213.356 146.875C176.791 146.875 147.027 176.639 147.027 213.204C147.027 249.769 176.791 279.534 213.356 279.534C249.921 279.534 279.686 249.769 279.686 213.204C279.686 176.639 249.921 146.875 213.356 146.875Z"
        fill="#3376FE"
        fill-opacity="0.2"
      />
      <path
        d="M213.354 248.835C193.724 248.835 177.749 232.86 177.749 213.23C177.749 193.601 193.724 177.598 213.354 177.598C232.983 177.598 248.985 193.574 248.985 213.23C248.959 232.86 232.983 248.835 213.354 248.835ZM213.354 180.265C195.191 180.265 180.416 195.041 180.416 213.23C180.416 231.419 195.191 246.168 213.354 246.168C231.516 246.168 246.318 231.393 246.318 213.23C246.318 195.068 231.516 180.265 213.354 180.265Z"
        fill="#3376FE"
        fill-opacity="0.2"
      />
    </svg>
  );
};
